import { getCurrentUserID } from 'src/modules/authentication/storage/user/utils';
import CommunityAPIs from '../../db/community';
import { mapCommunityToNode, mapPaginatedCommunities } from './utils';
export const epCommunityQueries = {
    async ep_communityDetails(_, { communityID }, context) {
        const result = await CommunityAPIs.getByID(getCurrentUserID(), communityID);
        return mapCommunityToNode(result);
    },
    async ep_communityList(_, { pagination }, context) {
        const result = await CommunityAPIs.getList(getCurrentUserID(), pagination);
        return mapPaginatedCommunities(result);
    },
};
